import { API_CALL_FAILURE, API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'
import { FETCH_TAILOR_MADE_TOUR, FETCH_TAILOR_MADE_TOUR_ORDER, FETCH_TOUR_OPERATORS, FETCH_TOUR_SEARCH_FACETS, SET_TOUR_PRICE_MODE, FETCH_TOUR_DEALS, FETCH_TOUR_DEAL, FETCH_TOUR_DEAL_DETAILS, FETCH_TOUR_DEAL_FACETS, FETCH_TOUR_REQUIREMENTS_TRAVEL_BY_TOUR_ID } from 'actions/apiActionConstants'
import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'

export const initialTourState: App.TourState = {
  tourFacets: {},
  tourOperators: {},
  tailorMadeTour: { initial: true },
  tailorMadeTourOrders: {},
  tourPriceMode: 'total',
  fetchingTourDealBySlugAndFacets: {},
  tourDeals: {},
  fetchingTourDeals: false,
  tourDealsDetails: {},
  fetchingTourDealDetailsBySlug: {},
  tourDealFacets: {},
  fetchingTourDealFacetsBySlug: {},

  fetchingRequirementTravel: {},
  requirementTravel: {},
  requirementTravelErrors: {},
}

const apiCalls = apiReducerSwitch<App.TourState>({
  [FETCH_TOUR_SEARCH_FACETS]: {
    request: (state, action) => ({
      tourFacets: {
        ...state.tourFacets,
        [action.key]: {
          fetching: true,
        },
      },
    }),
    success: (state, action) => ({
      tourFacets: {
        ...state.tourFacets,
        [action.key]: {
          data: action.data,
          fetching: false,
        },
      },
    }),
    failure: (state, action) => ({
      tourFacets: {
        ...state.tourFacets,
        [action.key]: {
          error: action.error,
          fetching: false,
        },
      },
    }),
  },
  [FETCH_TOUR_OPERATORS]: {
    request: (state) => ({
      tourOperators: {
        ...state.tourOperators,
        operators: {},
        fetching: true,
      },
    }),
    success: (state, action) => ({
      tourOperators: {
        ...state.tourOperators,
        operators: { ...action.data },
        fetching: false,
      },
    }),
    failure: (state, action) => ({
      tourOperators: {
        ...state.tourOperators,
        operators: {},
        fetching: false,
        error: action.error,
      },
    }),
  },
  [FETCH_TOUR_REQUIREMENTS_TRAVEL_BY_TOUR_ID]: {
    request: (state, action) => ({
      fetchingRequirementTravel: {
        ...state.fetchingRequirementTravel,
        [action.tourId]: true,
      },
    }),
    success: (state, action) => ({
      fetchingRequirementTravel: {
        ...state.fetchingRequirementTravel,
        [action.tourId]: false,
      },
      requirementTravel: {
        ...state.requirementTravel,
        [action.tourId]: action.data,
      },
    }),
    failure: (state, action) => ({
      fetchingRequirementTravel: {
        ...state.fetchingRequirementTravel,
        [action.tourId]: false,
      },
      requirementTravelErrors: {
        ...state.requirementTravelErrors,
        [action.tourId]: action.error,
      },
    }),
  },
  [FETCH_TAILOR_MADE_TOUR]: {
    request: () => {
      return {
        tailorMadeTour: { fetching: true },
      }
    },
    success: (_state, action) => {
      return {
        tailorMadeTour: { fetching: false, data: action.data },
      }
    },
    failure: (state, action) => {
      return {
        tailorMadeTour: { fetching: false, error: action.error },
      }
    },
  },
  [FETCH_TAILOR_MADE_TOUR_ORDER]: {
    request: (state, action) => {
      return {
        tailorMadeTourOrders: {
          ...state.tailorMadeTourOrders,
          [action.tailorMadeTourRequestId]: { fetching: true },
        },
      }
    },
    success: (state, action) => {
      return {
        tailorMadeTourOrders: {
          ...state.tailorMadeTourOrders,
          [action.tailorMadeTourRequestId]: { fetching: false, data: action.data },
        },
      }
    },
    failure: (state, action) => {
      return {
        tailorMadeTourOrders: {
          ...state.tailorMadeTourOrders,
          [action.tailorMadeTourRequestId]: {
            fetching: false,
            error: String(action.error),
          },
        },
      }
    },
  },
  [FETCH_TOUR_DEALS]: {
    request: () => ({
      tourDeals: {},
      fetchingTourDeals: true
    }),
    success: (_, action) => ({
      tourDeals: action.data,
      fetchingTourDeals: false,
    }),
    failure: () => ({
      tourDeals: {},
      fetchingTourDeals: false
    }),
  },
  [FETCH_TOUR_DEAL]: {
    request: (state, action) => ({
      fetchingTourDealBySlugAndFacets: {
        ...state.fetchingTourDealBySlugAndFacets,
        [action.slug]: true
      },
    }),
    success: (state, action) => ({
      tourDeals: {
        ...state.tourDeals,
        [action.slug]: action.data,
      },
      fetchingTourDealBySlugAndFacets: {
        ...state.fetchingTourDealBySlugAndFacets,
        [action.slug]: false
      },
    }),
    failure: (state, action) => ({
      fetchingTourDealBySlugAndFacets: {
        ...state.fetchingTourDealBySlugAndFacets,
        [action.slug]: false,
      },
    }),
  },
  [FETCH_TOUR_DEAL_DETAILS]: {
    request: (state, action) => ({
      fetchingTourDealDetailsBySlug: {
        ...state.fetchingTourDealDetailsBySlug,
        [action.slug]: true
      },
    }),
    success: (state, action) => ({
      tourDealsDetails: {
        ...state.tourDealsDetails,
        [action.slug]: action.data,
      },
      fetchingTourDealDetailsBySlug: {
        ...state.fetchingTourDealDetailsBySlug,
        [action.slug]: false
      },
    }),
    failure: (state, action) => ({
      fetchingTourDealDetailsBySlug: {
        ...state.fetchingTourDealDetailsBySlug,
        [action.slug]: false,
      },
    }),
  },
  [FETCH_TOUR_DEAL_FACETS]: {
    request: (state, action) => ({
      fetchingTourDealFacetsBySlug: {
        ...state.fetchingTourDealFacetsBySlug,
        [action.slug]: true
      },
    }),
    success: (state, action) => ({
      tourDealFacets: {
        ...state.tourDealFacets,
        [action.slug]: action.data,
      },
      fetchingTourDealFacetsBySlug: {
        ...state.fetchingTourDealFacetsBySlug,
        [action.slug]: false
      },
    }),
    failure: (state, action) => ({
      fetchingTourDealFacetsBySlug: {
        ...state.fetchingTourDealFacetsBySlug,
        [action.slug]: false,
      },
    }),
  },
})

export default createAppReducer<App.TourState>(initialTourState, {
  [API_CALL_REQUEST]: (state, action) => apiCalls(state, action),
  [API_CALL_FAILURE]: (state, action) => apiCalls(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiCalls(state, action),
  [SET_TOUR_PRICE_MODE]: (state, action) => ({
    ...state,
    tourPriceMode: action.tourPriceMode,
  }),
})
